import { render, staticRenderFns } from "./IcmsVigenciaForm.vue?vue&type=template&id=5c30c59e"
import script from "./IcmsVigenciaForm.vue?vue&type=script&lang=js"
export * from "./IcmsVigenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports